import React, { useState, useEffect } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonList, IonItem, IonLabel, IonTextarea } from '@ionic/react';
import { useParams, useHistory } from 'react-router-dom';
import config from '../config'; // Import config

function TreeProfile() {
  const { id } = useParams();
  const history = useHistory();
  const [tree, setTree] = useState(null);
  const [comment, setComment] = useState('');

  useEffect(() => {
    fetch(`${config.API_BASE_URL}/trees/${id}`)
      .then(res => res.json())
      .then(data => setTree(data));
  }, [id]);

  const handleCommentSubmit = () => {
    fetch(`${config.API_BASE_URL}/trees/${id}/comments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ content: comment })
    }).then(() => {
      setComment('');
      window.location.reload();
    });
  };

  if (!tree) return <IonPage><IonContent>Loading...</IonContent></IonPage>;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{tree.name}</IonTitle>
          <IonButton slot="end" onClick={() => history.push('/')}>Home</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <h2>{tree.name}</h2>
        <p>Species: {tree.species}</p>
        <p>Description: {tree.description}</p>
        <IonList>
          <IonItem>
            <IonLabel>Comments coming soon...</IonLabel>
          </IonItem>
        </IonList>
        <IonItem>
          <IonLabel position="stacked">Add Comment</IonLabel>
          <IonTextarea value={comment} onIonChange={e => setComment(e.target.value)}></IonTextarea>
        </IonItem>
        <IonButton expand="block" onClick={handleCommentSubmit}>Submit Comment</IonButton>
      </IonContent>
    </IonPage>
  );
}

export default TreeProfile;